<template>
<div class="chapter">
<div class="inner_page">
<div style="display:none;"><a id="GBS.PA8"></a><a id="GBS.PA8.w.0.0.0"></a></div>
<div class="flow" style="">
<a class="page" id="ORIG-GBS.PA9"></a>
<div class="gtxt_body" id="block.20.0.0.box.174.613.1347.196.q.80">
<a id="ORIG-GBS.PA9.w.0.0.0"></a><p class="gtxt_body gtxt_heading" id="para.20.0.0.box.522.613.641.79.q.80" style="text-align:center;"><a id="GBS.PA9"></a><a id="GBS.PA9.w.0.0.0"></a><a id="GBS.PA9.w.1.0.0"></a>The Theriots:</p><a id="GBS.PA9.w.1.1.0"></a><a id="GBS.PA9.w.2.0.0"></a><a id="GBS.PA9.w.2.1.0"></a><a id="GBS.PA9.w.3.0.0"></a><a id="GBS.PA9.w.3.1.0"></a><a id="GBS.PA9.w.4.0.0"></a><a id="GBS.PA9.w.4.1.0"></a><a id="GBS.PA9.w.5.0.0"></a><a id="GBS.PA9.w.5.1.0"></a><a id="GBS.PA9.w.6.0.0"></a><a id="GBS.PA9.w.6.1.0"></a><a id="GBS.PA9.w.7.0.0"></a><a id="GBS.PA9.w.7.1.0"></a><a id="GBS.PA9.w.8.0.0"></a><a id="GBS.PA9.w.8.1.0"></a><a id="GBS.PA9.w.9.0.0"></a><a id="GBS.PA9.w.9.1.0"></a><a id="GBS.PA9.w.10.0.0"></a><a id="GBS.PA9.w.10.1.0"></a><a id="GBS.PA9.w.11.0.0"></a><a id="GBS.PA9.w.12.0.0"></a><a id="GBS.PA9.w.12.1.0"></a><a id="GBS.PA9.w.13.0.0"></a><a id="GBS.PA10"></a><a id="GBS.PA10.w.0.0.0"></a><a id="GBS.PA10.w.0.1.0"></a><a id="GBS.PA10.w.0.2.0"></a><a id="GBS.PA10.w.0.3.0"></a>
<a id="GBS.PA10.w.0.3.0.1"></a><a id="GBS.PA10.w.0.4.0"></a><a id="ORIG-GBS.PA9.w.0.1.0"></a><p class="gtxt_body gtxt_heading" id="para.20.0.1.box.174.711.1347.98.q.80" style="font-variant:small-caps;"><a id="GBS.PA10.w.0.5.0"></a><a id="GBS.PA10.w.1.0.0"></a><a id="GBS.PA10.w.2.0.0"></a>One Cajun Family'<a id="GBS.PA10.w.2.1.0"></a><a id="GBS.PA10.w.3.0.0"></a>s Ancestry</p><a id="GBS.PA10.w.3.1.0"></a><a id="GBS.PA10.w.3.2.0"></a>
</div><a id="GBS.PA10.w.3.3.0"></a><a id="GBS.PA10.w.4.0.0"></a>
<div class="gimg_graphic" id="block.20.1.0.box.172.1095.1355.1190.q.50"><a id="GBS.PA10.w.4.1.0"></a>
<a id="GBS.PA10.w.4.2.0"></a><img alt="[graphic]" src="data/content-0009.png" style="max-width:100%; max-height:100%"/><a id="GBS.PA10.w.4.2.0.1"></a></div><a id="GBS.PA10.w.4.3.0"></a><a id="GBS.PA10.w.5.0.0"></a>
</div><div style="display:none;"><a id="GBS.PA11"></a><a id="GBS.PA11.w.0.0.0"></a></div>
<div class="flow" style="">
<a class="page" id="ORIG-GBS.PA10"></a>
<div class="gimg_graphic" id="block.21.0.0.box.170.267.1353.1467.q.50">
<a id="GBS.PA11.w.0.0.0.1"></a><img alt="[graphic]" src="data/content-0010.png" style="max-width:100%; max-height:100%"/><a id="GBS.PA11.w.0.0.0.2"></a></div>
</div>
<div style="display:none;"><a id="GBS.PA11.w.0.0.0.3"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content-0011.vue?442c80b1